<template>
  <div>
    <CrudList
      title="Estadias realizadas"
      storeName="Rent_orders"
      parentStoreName="Users"
      parentUrlKey="user_id"
      labelAddNew="Agregar"
      :canAdd="false"
      :canEdit="true"
      :canDelete="true"
      labelBack="Atrás"
    >
      <!-- <template v-slot:time_from="{ item }">
        <p>{{item.time_from? formatDateForSave(item.time_from): ''}}</p>
      </template>

      <template v-slot:time_to="{ item }">
        <p>{{item.time_to? formatDateForSave(item.time_to): ''}}</p>
      </template> -->
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import CrudFormMixin from '@/mixins/crud_form';
  export default {
    mixins: [CrudFormMixin],
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
